module.exports = __webpack_public_path__ + "media/2_2-6.43d12e44.mp3";